module.exports = __webpack_public_path__ + "static/TRAINING-46b1959eba66dd69ed8a4a116410e491.png";